import { Component } from "@angular/core";
import { LandingDisclaimerComponent } from "./landing-disclaimer/landing-disclaimer.component";
import { WelcomeCardComponent } from "./welcome-card/welcome-card.component";

@Component({
  selector: "app-landing",
  imports: [
    WelcomeCardComponent,
    LandingDisclaimerComponent,
  ],
  templateUrl: "./landing.component.html",
  styleUrl: "./landing.component.scss",
})
export class LandingComponent {

}
